import React from 'react';
import AppBar from '../../../commons/AppBar'
import ButtonsModules from '../../../commons/ButtonsModules';
import SiteMap  from '../../../commons/SiteMap';
import SpecificComponent from '../../../commons/SpecificComponent';
import { Grid, List, ListItem } from '@material-ui/core';
import { TopButtons } from '../../../commons/TopButtons';
import FromServer from '../FromServer';
import BilantChartData from '../Components/BilantChartData';
import PreviziuniChartData from '../Components/PreviziuniChartData';
import TrendDePastrareClientiTrimestru from '../TrendDePastrareClientiTrimestru';
import AnalizeClienti from '../Analize';


export default class ClientiCastigati extends SpecificComponent {
    constructor(props) {
      super(props);
       this.state = {
      listCastigati:[],
      
        
       mapButtons: [{ id: 'financiarcontabil', label: 'Inapoi Financiar', color: '#900DCB' },
       { id: 'avc', label: 'Analiza de vanzari si client (AVC)', color: '#900DCB' },
       { id: 'analizaclientilornoi', label: 'Analiza clientilor noi, loaiali si pierduti', color: '#900DCB' },
       { id: 'segmentareclienti', label: 'Segmentare clienti in functie de stare', color: '#900DCB' }
       ]
}
    }

     componentDidMount(){
        this.getClientiCastigati()
    }

    getClientiCastigati = async() =>{
        let a = new AnalizeClienti();


        let cC = await  a.getClientiCastigati()   

        // console.log('cC :', cC);
        this.setState({
            listCastigati:cC
        })
    }

    goBack = (id) =>{
        this.props.history.push(`/${id}`)
    }

  
     render() { 
       return (
          <div>
                <AppBar history={this.props.history} title={this.dictionary.appBar.drawer.financiar} />
             
                <ButtonsModules history={this.props.history}
                    scop={'Financiar'} />

        <div style={{textAlign:'left'}}>
            {this.state.mapButtons.map((b,idx)=>{
                return(
                    <SiteMap 
                        key={idx}
                        b={b}
                        buttonSelected={this.goBack} />
                        
                )
            })}
        </div>
        <h1 className='pm-title'>Clienti castigati</h1>
     
        <div>
      
                {this.state.listCastigati.length === 0 && <span style={{color:'red'}}>{this.dictionary.financiarContabil.nuExista}</span>}
                <List>
                        {this.state.listCastigati.map((l,idx)=>{
                            return(
                               
                                 
                           
                                <ListItem key={idx} style={{textAlign:'center', justifyContent:'center'}}> 
                                    <span className='pm-title'>{l}</span>
                                </ListItem>
                            )
                        })}
                    </List>
            </div>
         </div>
        );
       }
}